import React, { lazy, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import AOS from "aos";
// El CSS completo de aos (26 KB, con animaciones/timing que el proyecto
// nunca usa) se reemplazó por las 3 reglas necesarias en src/index.css.
import LandingPage from "./pages/LandingPage";

import { ScrollProvider } from "./context/ScrollContext";
import chakraTheme from "./theme/chakra-theme.";
import { Layout } from "./components/layouts/Layout";
import { ScrollToTop } from "./components/layouts/ScrollToTop";

// FAQ y ContactForm son rutas secundarias: se cargan solo cuando alguien
// navega a ellas, en vez de sumar su JS al bundle inicial de "/".
const FAQ = lazy(() =>
  import("./components/FAQ").then((m) => ({ default: m.FAQ }))
);
const ContactForm = lazy(() =>
  import("./components/ContactForm").then((m) => ({ default: m.ContactForm }))
);
// import { BlogListPage } from "./pages/blog/BlogListPage";
// import { BlogPostPage } from "./pages/blog/BlogPostPage";
// import { BlogAdminPage } from "./pages/admin/BlogAdminPage";
// import { BlogEditorPage } from "./pages/admin/BlogEditorPage";

const App: React.FC = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <ChakraProvider theme={chakraTheme}>
      <Router>
        <ScrollProvider>
          <ScrollToTop />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<LandingPage />} />
              <Route path="/faqs" element={<FAQ />} />
              <Route path="/contactos" element={<ContactForm />} />
              {/* <Route path="/blog" element={<BlogListPage />} /> */}
              {/* <Route path="/blog/:slug" element={<BlogPostPage />} /> */}
              {/* <Route path="/admin/blog" element={<BlogAdminPage />} /> */}
              {/* <Route path="/admin/blog/nuevo" element={<BlogEditorPage />} /> */}
              {/* <Route path="/admin/blog/:id/editar" element={<BlogEditorPage />} /> */}
            </Route>
          </Routes>
        </ScrollProvider>
      </Router>
    </ChakraProvider>
  );
};

export default App;

